import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('tsoDetailsHeader', tsoDetailsHeader);

    /**
     * @author flzemke.btc
     * @ngInject
     */
    function tsoDetailsHeader() {
        return {
            restrict: 'E',
            scope: {
                title: '@',
                downloadCsv: '&'
            },
            template: require('app/_directives/tso-details-header.directive.html')
        };
    }
})();
